module.exports = "mutation DeleteAttributeGroup($groupId:ID!){deleteAttributeGroup(groupId:$groupId){success}}"